import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";
import {
    displayConsumerCareerStatus,
    displayMentorStatus,
    displayPhoneNumber,
    displayProviderCareerStatus,
    displayProviderServiceYears,
    displayUserRole,
    displayUserState,
    formatDate
} from "../util/helpers";

const typeLabel = (type) => {
    switch (type) {
        case 'CHARGE': return '충전';
        case 'CHARGE_CANCEL': return '충전 취소';
        case 'PAYMENT': return '서비스 이용';
        case 'SALE_PROFIT': return '판매 수익';
        case 'CANCEL_PROFIT': return '취소 수익';
        case 'WITHDRAWAL': return '출금';
        case 'ADJUSTMENT': return '수수료 조정';
        case 'PAYMENT_FEE': return '플랫폼 수수료';
        case 'CANCEL_FEE': return '취소 수수료';
        default: return type;
    }
};

const statusLabel = (status) => {
    switch (status) {
        case 'PENDING': return '정산 대기';
        case 'COMPLETED': return '정산 완료';
        case 'ON_HOLD': return '정산 중지';
        case 'CANCELLED': return '정산 취소';
        default: return status;
    }
};


export default function Detail() {
    const [member, setMember] = useState();
    const [wallet, setWallet] = useState();
    const [walletTxs, setWalletTxs] = useState([]);
    const [insightForm, setInsightForm] = useState({
        title: '',
        content: '',
        price: 5000,
        tradeType: 'BUY',
        consultMinutes: 30,
        tag: '',
        postArea: 'MOCK_INTERVIEW'
    });
    const [showInsightModal, setShowInsightModal] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const userId = queryParams.get("userId");

    const requestData = (e) => {
        axios.get(`/admin/v1/members/${userId}`)
            .then((res) => {
                setMember(res.data);
            });
    }

    const requestWallet = () => {
        return axios.get(`/admin/v1/members/${userId}/wallet`)
            .then(res => setWallet(res.data));
    }
    
    const requestWalletTxs = () => {
        return axios.get(`/admin/v1/members/${userId}/wallet/transactions`)
            .then(res => setWalletTxs(res.data || []));
    }

    const requestUpdate = (mentorStatus) => {
        const params = new URLSearchParams();
        params.append('mentorStatus', mentorStatus);

        axios.put(`/admin/v1/members/${userId}/provider`, params, {
            headers: {'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'}
        })
        .then((res) => {
            alert('수정되었습니다.');
            requestData();
        });
    }

    const requestDelete = () => {
        if (!userId) return;
        if (!window.confirm('해당 회원을 탈퇴 처리하시겠습니까? 이 작업은 되돌릴 수 없습니다.')) return;
        axios.delete(`/admin/v1/members/${userId}`)
            .then(() => {
                alert('탈퇴 처리되었습니다.');
                document.location.reload();
            })
            .catch(err => {
                console.error(err);
                alert('탈퇴 처리에 실패했습니다. 잠시 후 다시 시도해주세요.');
            });
    }

    const requestUpdateEmbedding = () => {
        if (!userId) return;
        if (!window.confirm('임베딩을 업데이트하시겠습니까?')) return;
        axios.post(`/admin/v1/members/${userId}/embedding/update`)
            .then(() => {
                alert('업데이트되었습니다.');
                requestData();
            })
            .catch(err => {
                console.error(err);
                alert('업데이트에 실패했습니다.');
            });
    }

    const handleInsightFormChange = (e) => {
        const {name, value} = e.target;
        setInsightForm({...insightForm, [name]: name === 'price' || name === 'consultMinutes' ? parseInt(value) : value});
    };

    const handleCreateInsight = (e) => {
        e.preventDefault();
        if (!userId) return;
        
        axios.post(`/admin/v1/members/${userId}/insights`, insightForm)
            .then(() => {
                alert('게시글이 등록되었습니다.');
                setShowInsightModal(false);
                setInsightForm({
                    title: '',
                    content: '',
                    price: 5000,
                    tradeType: 'BUY',
                    consultMinutes: 30,
                    tag: '',
                    postArea: 'MOCK_INTERVIEW'
                });
            })
            .catch(err => {
                console.error(err);
                alert('게시글 등록에 실패했습니다.');
            });
    }

    useEffect(() => {
        requestData();
        requestWallet().then(() => requestWalletTxs());
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">회원관리 > 회원정보 > 상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">


                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title" style={{fontWeight: 'bold'}}>계정정보</h3>
                                            <div className="card-tools">
                                                <button className="btn btn-sm btn-success" onClick={() => setShowInsightModal(true)}>
                                                    <i className="fas fa-plus"></i> 게시글 등록
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive p-0">
                                            <table className="table table-hover text-nowrap">
                                                {member && (
                                                    <tbody>
                                                    <tr>
                                                        <th style={{width: '100px'}}>아이디</th>
                                                        <td>{member.id}</td>
                                                        <th style={{width: '100px'}}>extId</th>
                                                        <td>{member.extId}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>가입경로</th>
                                                        <td>{member.oauthType}</td>
                                                        <th>oauthId</th>
                                                        <td>{member.oauthId}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={{width: '100px'}}>이메일</th>
                                                        <td>{member.email}</td>
                                                        <th style={{width: '100px'}}>별명</th>
                                                        <td>{member.nickname}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>회원유형</th>
                                                        <td>
                                                            {
                                                                member.nickname === 'ADMIN'
                                                                        ? '관리자' : Array.isArray(member.roles)
                                                                                ? member.roles.map(role => displayUserRole(role)).join('/ ')
                                                                                : null
                                                            }
                                                        </td>
                                                        <th style={{width: '100px'}}>회원상태</th>
                                                        <td>{displayUserState(member.userState)}</td>
                                                    </tr>
                                                    </tbody>
                                                )}
                                                {/*</tbody>*/}
                                            </table>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}

                                    {member && member.mentor && (
                                        <div className="card" style={{marginTop: '50px'}}>
                                            <div className="card-header">
                                                <h3 className="card-title" style={{fontWeight: 'bold'}}>공급자 정보</h3>
                                            </div>
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-hover text-nowrap">
                                                    <tbody>
                                                    <tr>
                                                        <th style={{width: '100px'}}>회사명</th>
                                                        <td>{member.mentor.company}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={{width: '100px'}}>직군</th>
                                                        <td>{member.mentor.job}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={{width: '100px'}}>년차</th>
                                                        <td>{member.mentor.year}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={{width: '100px'}}>이메일</th>
                                                        <td>{member.mentor.email}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={{width: '100px'}}>이메일 인증여부</th>
                                                        <td colSpan={3}>{member.mentor.emailVerified ? 'TRUE' : 'FALSE'}</td>
                                                    </tr>
                                                    {/*{*/}
                                                    {/*    member.mentor.rejectReason && (*/}
                                                    {/*        <tr>*/}
                                                    {/*            <th style={{width: '100px'}}>반려사유</th>*/}
                                                    {/*            <td colSpan={3}>{mentor.rejectReason}</td>*/}
                                                    {/*        </tr>*/}
                                                    {/*    )*/}
                                                    {/*}*/}
                                                    </tbody>
                                                    {/*</tbody>*/}
                                                </table>
                                            </div>
                                            {/* /.card-body */}
                                        </div>
                                    )}

                                    {member && (
                                        <div className="card" style={{marginTop: '50px'}}>
                                            <div className="card-header">
                                                <h3 className="card-title" style={{fontWeight: 'bold'}}>구매자 커리어 정보</h3>
                                            </div>
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-hover text-nowrap">
                                                    <tbody>
                                                    <tr>
                                                        <th style={{width: '200px'}}>커리어 상태</th>
                                                        <td>{displayConsumerCareerStatus(member.consumerStatus) || '-'}</td>
                                                        <th style={{width: '200px'}}>경력 연차</th>
                                                        <td>{member.consumerExperienceYears}년</td>
                                                    </tr>
                                                    <tr>
                                                        <th>현재/최근 산업</th>
                                                        <td>{member.consumerCurrentIndustry || '-'}</td>
                                                        <th>현재/최근 직무</th>
                                                        <td>{member.consumerCurrentRole || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>목표 직무</th>
                                                        <td colSpan={3}>{member.consumerTargetRole || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>희망 서비스 영역</th>
                                                        <td colSpan={3}>{member.consumerTargetAreas?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>현재 회사 유형</th>
                                                        <td colSpan={3}>{member.consumerCurrentCompanyTypes?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>목표 산업</th>
                                                        <td colSpan={3}>{member.consumerTargetIndustries?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>목표 회사 유형</th>
                                                        <td colSpan={3}>{member.consumerTargetCompanyTypes?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>얻고 싶은 스킬/역량</th>
                                                        <td colSpan={3}>{member.consumerTargetSkills?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>임베딩 텍스트(Context)</th>
                                                        <td colSpan={3} style={{whiteSpace: 'pre-wrap'}}>
                                                            {member.consumerContext || '-'}
                                                            <button className="btn btn-xs btn-primary" style={{marginLeft: '10px'}} onClick={requestUpdateEmbedding}>업데이트</button>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}

                                    {member && Array.isArray(member.roles) && member.roles.includes('PROVIDER') && (
                                        <div className="card" style={{marginTop: '50px'}}>
                                            <div className="card-header">
                                                <h3 className="card-title" style={{fontWeight: 'bold'}}>판매자 커리어 정보</h3>
                                            </div>
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-hover text-nowrap">
                                                    <tbody>
                                                    <tr>
                                                        <th style={{width: '200px'}}>커리어 상태</th>
                                                        <td>{displayProviderCareerStatus(member.providerStatus) || '-'}</td>
                                                        <th style={{width: '200px'}}>경력 연차</th>
                                                        <td>{member.providerExperienceYears}년</td>
                                                    </tr>
                                                    <tr>
                                                        <th>현재 산업(단일)</th>
                                                        <td>{member.providerCurrentIndustry || '-'}</td>
                                                        <th>현재 직무</th>
                                                        <td>{member.providerCurrentRole || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>핵심 스킬/강점</th>
                                                        <td>{member.providerServiceSkills?.join(', ') || '-'}</td>
                                                        <th>서비스 제공 연차 레벨</th>
                                                        <td>{displayProviderServiceYears(member.providerServiceYears) || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>현재 회사 유형</th>
                                                        <td colSpan={3}>{member.providerCurrentCompanyTypes?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>서비스 가능 산업</th>
                                                        <td colSpan={3}>{member.providerServiceIndustries?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>서비스 제공 가능 회사 유형</th>
                                                        <td colSpan={3}>{member.providerServiceCompanyTypes?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>서비스 가능 직무</th>
                                                        <td colSpan={3}>{member.providerServiceRoles?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>제공 가능한 서비스 영역</th>
                                                        <td colSpan={3}>{member.providerServiceAreas?.join(', ') || '-'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>임베딩 텍스트(Context)</th>
                                                        <td colSpan={3} style={{whiteSpace: 'pre-wrap'}}>
                                                            {member.providerContext || '-'}
                                                            <button className="btn btn-xs btn-primary" style={{marginLeft: '10px'}} onClick={requestUpdateEmbedding}>업데이트</button>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}

                                    {showInsightModal && (
                                        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
                                            <div className="modal-dialog modal-lg">
                                                <div className="modal-content">
                                                    <form onSubmit={handleCreateInsight}>
                                                        <div className="modal-header">
                                                            <h4 className="modal-title">게시글 등록</h4>
                                                            <button type="button" className="close" onClick={() => setShowInsightModal(false)}>
                                                                <span>&times;</span>
                                                            </button>
                                                        </div>
                                                        <div className="modal-body">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>거래 유형</label>
                                                                        <select name="tradeType" className="form-control" value={insightForm.tradeType} onChange={handleInsightFormChange}>
                                                                            <option value="BUY">구매 요청 (BUY)</option>
                                                                            {member && member.roles?.includes('PROVIDER') && (
                                                                                <option value="SELL">판매 제안 (SELL)</option>
                                                                            )}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>서비스 영역</label>
                                                                        <select name="postArea" className="form-control" value={insightForm.postArea} onChange={handleInsightFormChange}>
                                                                            <option value="MOCK_INTERVIEW">모의 면접</option>
                                                                            <option value="CV_REVIEW">이력서 피드백</option>
                                                                            <option value="PORTFOLIO_REVIEW">포트폴리오 피드백</option>
                                                                            <option value="CAREER_PATH">커리어 방향성</option>
                                                                            <option value="JOB_FIT">직무핏</option>
                                                                            <option value="CAREER_INFO">현직자 꿀팁/정보</option>
                                                                            <option value="INDUSTRY_INFO">산업/기업 정보</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label>제목</label>
                                                                <input type="text" name="title" className="form-control" value={insightForm.title} onChange={handleInsightFormChange} required maxLength={30} />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>내용</label>
                                                                <textarea name="content" className="form-control" rows="5" value={insightForm.content} onChange={handleInsightFormChange} required maxLength={1000}></textarea>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>가격 (원)</label>
                                                                        <input type="number" name="price" className="form-control" value={insightForm.price} onChange={handleInsightFormChange} min={1000} step={1000} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label>상담 시간 (분)</label>
                                                                        <input type="number" name="consultMinutes" className="form-control" value={insightForm.consultMinutes} onChange={handleInsightFormChange} min={10} step={10} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label>태그 (쉼표로 구분)</label>
                                                                <input type="text" name="tag" className="form-control" placeholder="예: 면접, 취업, 커리어" value={insightForm.tag} onChange={handleInsightFormChange} />
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer justify-content-between">
                                                            <button type="button" className="btn btn-default" onClick={() => setShowInsightModal(false)}>취소</button>
                                                            <button type="submit" className="btn btn-primary">등록</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {wallet && (
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card" style={{marginTop: '50px'}}>
                                            <div className="card-header">
                                                <h3 className="card-title" style={{fontWeight: 'bold'}}>지갑 정보</h3>
                                            </div>
                                            <div className="card-body table-responsive p-0">
                                                <table className="table table-hover text-nowrap">
                                                    <tbody>
                                                    <tr>
                                                        <th style={{width: '120px'}}>지갑ID</th>
                                                        <td>{wallet.walletId}</td>
                                                        <th>수정일</th>
                                                        <td>{formatDate(wallet.updatedAt)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={{width: '120px'}}>충전금액</th>
                                                        <td>{wallet.prepaidBalance?.toLocaleString?.() || wallet.prepaidBalance}</td>
                                                        <th style={{width: '120px'}}>정산 예정 금액(에스크로 보류 중인 판매자 수익)</th>
                                                        <td>{wallet.escrowBalance?.toLocaleString?.() || wallet.escrowBalance}</td>
                                                    </tr>
                                                    <tr>
                                                        <th style={{width: '120px'}}>출금 가능 금액(정산 완료된 판매자 수익)</th>
                                                        <td>{wallet.withdrawableBalance?.toLocaleString?.() || wallet.withdrawableBalance}</td>
                                                        <th style={{width: '120px'}}>출금 신청중 금액</th>
                                                        <td>{wallet.requestedWithdrawalBalance?.toLocaleString?.() || wallet.requestedWithdrawalBalance}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title" style={{fontWeight: 'bold'}}>지갑 거래 이력</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0">
                                            <table className="table table-hover text-nowrap" style={{textAlign: 'center'}}>
                                                <thead>
                                                <tr>
                                                    <th>거래ID</th>
                                                    <th>유형</th>
                                                    <th>상태</th>
                                                    <th>금액</th>
                                                    {/*<th>출금 가능 금액</th>*/}
                                                    <th>결제ID</th>
                                                    <th>설명</th>
                                                    <th>발생일시</th>
                                                    <th>정산 예정 일시</th>
                                                    <th>정산 완료 일시</th>
                                                    <th>조정내역</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {walletTxs && walletTxs.map(tx => (
                                                    <tr key={tx.id}>
                                                        <td>{tx.id}</td>
                                                        <td>{typeLabel(tx.type)}</td>
                                                        <td>{statusLabel(tx.status)}</td>
                                                        <td>{tx.amount}</td>
                                                        {/*<td>{tx.balanceAfter}</td>*/}
                                                        <td>
                                                            {tx.paymentId ? (
                                                                <a href={`/page/payments/detail?id=${tx.paymentId}`} target="_blank" rel="noopener noreferrer">{tx.paymentId}</a>
                                                            ) : '-' }
                                                        </td>
                                                        <td style={{textAlign: 'center'}}>{tx.description || '-'}</td>
                                                        <td>{formatDate(tx.createdAt)}</td>
                                                        <td>{formatDate(tx.releaseAt)}</td>
                                                        <td>{formatDate(tx.releasedAt)}</td>
                                                        <td style={{textAlign: 'left'}}>
                                                            {tx.adjustments && tx.adjustments.length > 0 ? (
                                                                tx.adjustments.map(adj => (
                                                                    <div key={adj.id}>{adj.amount} ({adj.reason})</div>
                                                                ))
                                                            ) : '-'}
                                                        </td>
                                                    </tr>
                                                ))}
                                                {(!walletTxs || walletTxs.length === 0) && (
                                                    <tr>
                                                        <td colSpan={9} style={{textAlign: 'center'}}>거래 이력이 없습니다.</td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                <div style={{margin: "0 auto"}}>
                                    {
                                        member && member.mentor?.status == 'REQUESTED' && (
                                            <>
                                                <button type="button" className="btn btn-outline-danger"
                                                        onClick={ e => requestUpdate('REJECTED')}>
                                                    반려
                                                </button>
                                                <button type="button" className="btn btn-outline-success"
                                                        style={{marginLeft: '10px'}}
                                                        onClick={ e => requestUpdate('APPROVED')}>
                                                    승인
                                                </button>
                                            </>
                                        )
                                    }
                                    {
                                            member && member.userState != 'WITHDRAWN' && member.nickname != 'ADMIN' && (
                                                    <button type="button" className="btn btn-outline-danger"
                                                            onClick={requestDelete}>
                                                        탈퇴처리
                                                    </button>
                                            )
                                    }
                                    <button type="button" className="btn btn-outline-dark"
                                            style={{marginLeft: '10px'}}
                                            onClick={e => navigate(-1)}>
                                        목록
                                    </button>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
